<template lang="html">
  <div class="moremenu"  :class="{sbActive: drop}">
    <ul class="menus pc">
        <li @click="menuFilter(-1, null)" :class="{active: currItem == -1}">All</li>
      <template v-for="(item, index) in category">
        <li @click="menuFilter(index, item.cid)" :class="{active: currItem == index}">{{item.cname}}</li>
        <!-- <li @click="menuFilter(index, item.cid, item.cname)" class="active">{{item.cname}}</li> -->
      </template>
    </ul>
    <ul class="menus mobile">
        <li @click="sideMenuFilter(-1, null, 'All')">All</li>
      <template v-for="(item, index) in category">
        <li @click="sideMenuFilter(index, item.cid, item.cname)">{{item.cname}}</li>
        <!-- <li @click="menuFilter(index, item.cid, item.cname)" class="active">{{item.cname}}</li> -->
      </template>
    </ul>
  </div>
</template>

<script>
import {GetProductList} from '@/api/index.js'
export default {
  data(){
    return{
      category:null,
      loading:false,
      curpage:1,
      cid:null,
      keyword:null,
      currItem:-1,
      bid:null,
    }
  },
  props:{
    drop:{
      default:false,
    },
    brandid:{
      default:null,
    }
  },
  created(){
    if(this.$route.query.bid){
      this.bid = this.$route.query.bid;
    }
    if(this.$route.query.item){
      this.currItem = this.$route.query.item;
    }
    if(this.brandid){
      if(this.brandid == -1){
        this.bid = null;
      } else{
        this.bid = this.brandid;
      }
    }
    this.initData()
  },
  methods:{
    initData(){
      this.loading = true;
      console.log('bid= ' + this.bid);
      GetProductList({'page_no':this.curpage,'sort_field':'price','sort':'asc','cid':this.cid,'brand_id':this.bid,'keyword':this.keyword})
      .then(res => {
        this.category = res.data.category;
        console.log(this.category)
        this.loading = false;
      })
    },
    menuFilter: function(index, cid){
      // console.log(index);
      localStorage.setItem('currItem',index);
      // console.log('current item: ' + currItem);
      this.$parent.menuFilter(this.bid, cid);
    },
    sideMenuFilter: function(index, cid, cname){
      // console.log(index);
      localStorage.setItem('currItem',index);
      // console.log('current item: ' + currItem);
      this.$parent.storeFilter('cid', cid, cname);
    },
    close(){
      this.$emit('close')
    }
  }
}
</script>

<style lang="css" scoped>
  .moremenu{
    color:white;
    font-size: 25px;
    width: 88%;
    max-width: 1140px;
    text-align: left;
    margin:0 auto;
    white-space: nowrap;
  }
  .menus{
    overflow: auto;
  }
  ul{
    list-style: none;
    padding:0;
  }
  li, p{
    padding:10px 25px;
    background: #ccc;
    display: inline-block;
    border-radius: 30px;
    text-align: center;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  li:hover, p:hover{
    cursor:pointer;
    background: rgb(92, 99, 102);
  }
  .active{
    background: rgb(92, 99, 102);
  }

  .mobile{
    display: none;
  }

  @media screen and (max-width:900px){
    .pc{
      display:none;
    }
    .mobile{
      display:block;
    }
    .moremenu{
      background: #c0d1d6;
      width: 80%;
      position: absolute;
      z-index: 3;
      top: 35px;
      /* border-radius: 15px; */
      left: 50%;
      /* padding: 50px 0 12px; */
      transform: translateX(-50%);
      height: 20px;
      overflow: auto;
      transition: 0.3s ease-in-out;
      /* display: none; */
      opacity: 0;
    }
    .sbActive{
      border-radius: 10px;
      padding: 50px 0 12px;
      height: 108px;
      transition: 0.2s ease-out;
      opacity: 1;

    }
    ul li {
      padding: 12px 0;
      color: #47666f;
      display: block;
      font-size: 16px;

        border-radius: 0;
        background: none;
        margin:0;
    } li:hover{
      background: none;
      cursor:auto;
    }
    .active{
      font-weight: bold;
      background: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MoreMenu.vue